export default __webpack_public_path__ + "static/media/next.8b846e78.svg";